var _circle, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMongoDbAnimationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.336 49.8037L29.322 49.4675C29.322 49.4675 29.457 44.337 27.6006 43.9765C26.3855 42.5616 27.7802 -16.4296 32.2221 43.7754C31.3793 44.2028 30.7345 44.9396 30.4224 45.8316C30.2551 47.149 30.2261 48.4803 30.336 49.8037V49.8037Z",
    fill: "url(#paint0_linear_1466_1134)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8841 44.8473C33.5838 42.8151 35.6513 40.0584 36.8462 36.8976C38.0412 33.7369 38.3147 30.3019 37.6347 26.9919C35.65 18.2363 30.9502 15.3578 30.4439 14.2588C30.0071 13.5744 29.6342 12.8513 29.3301 12.0986L29.7041 36.4941C29.7041 36.4941 28.9291 43.9495 30.8841 44.8473Z",
    fill: "url(#paint1_linear_1466_1134)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8062 45.1713C28.8062 45.1713 20.542 39.5427 21.02 29.5854C21.0645 26.5836 21.7528 23.6263 23.0383 20.9133C24.3238 18.2003 26.1765 15.7947 28.4713 13.8591C28.7395 13.6313 28.9526 13.3456 29.0945 13.0236C29.2365 12.7016 29.3036 12.3517 29.2909 12C29.8053 13.1071 29.7215 28.5296 29.7756 30.3334C29.9848 37.35 29.3854 43.8469 28.8062 45.1713V45.1713Z",
    fill: "url(#paint2_linear_1466_1134)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1466_1134",
    x1: 23.52,
    y1: 31.2425,
    x2: 35.1739,
    y2: 35.1972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#999875"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#9B9977"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683,
    stopColor: "#A09F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#A9A889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#B7B69A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#C9C7B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#DEDDCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#F8F6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF9EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1466_1134",
    x1: 27.7936,
    y1: 11.9243,
    x2: 32.9457,
    y2: 44.0964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48A547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F9143"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1466_1134",
    x1: 20.3091,
    y1: 30.5711,
    x2: 34.1352,
    y2: 25.9407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41A247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#4BA74B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    stopColor: "#67B554"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69B655"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongoDbAnimationIcon);
export default __webpack_public_path__ + "static/media/mongoDbAnimationIcon.f73966adb16e1e8c6423dd626a1081dd.svg";
export { ForwardRef as ReactComponent };